import { useCallback, useEffect, useState } from "react";

import { getMemberAchievements } from "@/api/memberBenefit";
import type { MarketingAchievementMemberRowVO } from "@/api/memberBenefit/type";

export interface UseMemberAchievementsOptions {
  /** 会员 ID */
  memberId?: string | null;
  /** 门店 ID；接口必填，缺失时不请求 */
  shopId?: string | null;
  /** 是否启用拉取（如切到成就子 Tab） */
  enabled: boolean;
}

/**
 * 会员成就列表：GET …/members/{memberId}/achievements?shopId=
 */
export const useMemberAchievements = ({
  memberId,
  shopId,
  enabled,
}: UseMemberAchievementsOptions) => {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState<MarketingAchievementMemberRowVO[]>([]);

  const fetchAchievements = useCallback(async () => {
    if (!enabled || !memberId || !shopId) {
      setRecords([]);
      return;
    }
    setLoading(true);
    try {
      const res = await getMemberAchievements(memberId, shopId);
      setRecords(res.data ?? []);
    } catch {
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }, [enabled, memberId, shopId]);

  useEffect(() => {
    void fetchAchievements();
  }, [fetchAchievements]);

  return { loading, records, refresh: fetchAchievements };
};
